import { axios } from '@carvana/purchase-utils';

export const cancelOrder = payload =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/purchase/cancelpurchase`,
    data: payload
  })
    .then(res => res.data)
    .catch(err => Promise.reject(new Error(err?.response)));

export const editOrder = payload =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/purchase/rollback`,
    data: payload
  })
    .then(res => res.data)
    .catch(err => Promise.reject(new Error(err?.response)));

export const fetchOrderSummary = () => {
  return axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/dashboard/summary`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(new Error(err?.response)));
};

export const fetchOrderOptions = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/order/availableoptions`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(new Error(err?.response)));

export const getTransferScheduleTimeslots = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/scheduling/timeslots`
  }).then(res => res.data);

export const submitSelectedTimeSlot = payload =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/scheduling/scheduletransfer`,
    data: { ...payload }
  })
    .then(res => res.data)
    .catch(err => Promise.reject(new Error(err?.response)));
